import { NgModule, signal } from '@angular/core';
import { ACTIVE_SHOP_DOMAIN } from '@informally/frontend/active-shop';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { AppModule } from './app.module';

@NgModule({
  imports: [AppModule],
  providers: [
    {
      provide: ACTIVE_SHOP_DOMAIN,
      useValue: signal(
        environment.useDevSubdomain
          ? `${environment.useDevSubdomain}.${
              environment.shopDomainSuffix || environment.publicDomain
            }`
          : window.location.hostname,
      ),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppBrowserModule {}
